import { cloneElement } from "react";
import { Box, Container, Heading, Stack, Text } from "@chakra-ui/react";

import { Button } from "#app/components/ui/button.jsx";

// `buttonLink` is the link the button goes to, without its text: a router
// link (`<RemixLink to="/new" />`) or an `<a href>`. The button renders as
// that link, with `buttonText` inside.
export const CallToAction = ({
  heading,
  body,
  buttonText,
  buttonLink,
  buttonProps = {},
  ...props
}) => (
  <Container py={{ base: "8", md: "12" }} px={0} textAlign="initial" {...props}>
    <Box
      bg="bg-accent"
      color="on-accent"
      borderRadius="xl"
      px={{ base: "6", lg: "16" }}
      py={{ base: "10", lg: "16" }}
    >
      <Stack
        gap="8"
        direction={{ base: "column", lg: "row" }}
        justify="space-between"
      >
        <Stack gap="4" maxW="2xl">
          <Heading size="sm">{heading}</Heading>
          <Text color="on-accent-muted" fontSize="lg">
            {body}
          </Text>
        </Stack>
        <Stack
          gap="3"
          direction={{ base: "column", sm: "row" }}
          justify={{ base: "start" }}
        >
          <Button
            variant="primary-on-accent"
            size="lg"
            {...buttonProps}
            fontWeight="bold"
            asChild
          >
            {cloneElement(buttonLink, undefined, buttonText)}
          </Button>
        </Stack>
      </Stack>
    </Box>
  </Container>
);
